import { createFileRoute } from "@tanstack/react-router";
import type { ClientLocationPublicMapData } from "api-types/locations/locationsResponses";
import AdminPage from "lib/components/admin/builders/AdminPage";
import BuilderHeader from "lib/components/builders/BuilderHeader";
import PlanPicker from "lib/components/demo/PlanPicker";
import { DEBUG_SHOWROOM_INTRO_PATH } from "lib/components/showroom2/state/showroomTypes";
import { getBuilderLocationPublicMapURL } from "lib/endpointHelpers";
import { useFetch } from "lib/fetcher";
import { useAppRouterParams } from "lib/routeHelpers";
import ProductCard, { ProductCards } from "ui/cards/ProductCard";
import withAuthentication from "../../../components/withAuthentication";
import styles from "./index.module.scss";

function BuilderWebsiteDebug() {
  const { builderId, locationId, locationPlanId, masterPlanId, lotId } = useAppRouterParams();
  const planType = !locationPlanId ? "master_plans" : "community_plans";

  const { data: mapData } = useFetch<ClientLocationPublicMapData>(
    builderId && locationId ? getBuilderLocationPublicMapURL({ builderId, locationId }) : "",
    [builderId, locationId],
  );
  const hasSalesMap = !!(mapData?.location?.salesMapUrl || mapData?.location?.parentLocationSalesMapUrl);

  return (
    <AdminPage currentPage="debug" pageTitle="Builder Website">
      <BuilderHeader header="Builder Website" />
      <div className={styles.adminPageWrapper}>
        <PlanPicker className={styles.adminPage}>
          <ProductCards>
            <ProductCard
              title="Showroom Intro"
              subtitle="Embedded on a mock page"
              ctaText="Launch"
              href={`${DEBUG_SHOWROOM_INTRO_PATH}?builderId=${builderId}&planType=${planType}&planId=${
                locationPlanId || masterPlanId
              }${lotId ? `&lotId=${lotId}` : ""}`}
            />
            <ProductCard
              title="Sales Map"
              subtitle="Community map in an iframe"
              ctaText="Launch"
              href={`/debug/builder-website/sales-map?builderId=${builderId}&locationId=${locationId}`}
              disabled={!hasSalesMap}
            />
          </ProductCards>
        </PlanPicker>
      </div>
    </AdminPage>
  );
}

export const Route = createFileRoute("/debug/builder-website/")({
  component: withAuthentication(BuilderWebsiteDebug, { superAdmin: true }),
});
